// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"406":"7139f269","452":"8435043b"}[chunkId] + ".chunk.css";
};